export function getBarSeries(type) {
  let dimensions = [];
  let source = [];
  let color = [
    '#00AEFF', '#FFB400', '#3CC93C', '#3300ff',
    "#F6836E",
    "#FF9F4B",
    "#F6CE6E",
    "#F0681C",
    "#0188CC",
    "#025FBA",
    "#042E93",
  ];
  type.forEach((t) => {
    dimensions.push(t.name);
    source.push(t.value);
  });

  return {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c}%",
    },
    xAxis: {
      type: "category",
      axisLabel: {
        show: true,
        textStyle: {
          color: "#A6CAFF",
          fontSize: "16",
        },
        axisLine: {
          lineStyle: {
            color: "#8A9099",
            type: "dashed",
          },
        },
      },
      data: dimensions,
    },
    yAxis: {
      max: 100,
      name: '占比（%）',  // 在轴名称中显示单位
      nameTextStyle:{
        color:'#A6CAFF',
        fontSize: "16",
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#A6CAFF",
          fontSize: "16",
        },
      },
      // splitNumber: 4,
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        data: source,
        type: "bar",
        showBackground: true,
        barMaxWidth: "30%",
        itemStyle: {
          normal: {
            color: function (params) {
          
              return color[params.dataIndex % 7];
            },
          },
        },
      },
    ],
  };
}

export function getPieSeries(type, isBig, position) {
  return {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {d}%",
    },
    grid: {
      top: "50%",
    },
    series: [
      {
        name: "运输方式",
        type: "pie",
        selectedMode: "single",
        radius: isBig ? ["30%", "48%"] : ["15%", "30%"],
        label: {
          position: "inner",
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: type,
        center: position ? [position.x, position.y] : ['50%','50%']
      },
    ],
  };
}
export function getPieSeries2(type, isBig, position) {
  return {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {d}% （{c}吨）",
    },
    grid: {
      top: "50%",
    },
    series: [
      {
        name: "运输方式",
        type: "pie",
        selectedMode: "single",
        radius: isBig ? ["30%", "48%"] : ["25%", "40%"],
        label: {
          position: "inner",
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: type,
        center: position ? [position.x, position.y] : ['50%','50%']
      },
    ],
  };
}
